export default __webpack_public_path__ + "static/media/card-4.bff30d76.webp";